import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Infinity as InfinityIcon, Download, RefreshCw, Clock, Flame } from 'lucide-react';
import { Button } from './ui/Button';
const stack = [{
  icon: Check,
  text: '6 Tomos Digitales Completos'
}, {
  icon: Check,
  text: '4 Bonos Exclusivos de Acción Rápida'
}, {
  icon: Check,
  text: 'Certificado Profesional Editable'
}, {
  icon: InfinityIcon,
  text: 'Acceso de por vida al material'
}, {
  icon: RefreshCw,
  text: 'Actualizaciones futuras gratuitas'
}, {
  icon: Download,
  text: 'Archivos 100% descargables'
}];
export function WhatYouReceive() {
  return <section className="py-16 relative z-10 bg-[#0a0517]" data-id="element-152">
      <div className="container mx-auto px-4" data-id="element-153">
        {/* Premium offer banner ABOVE title */}
        <motion.div className="max-w-3xl mx-auto mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-154">
          <div className="relative rounded-3xl overflow-hidden p-[2px] bg-gradient-to-r from-[#fbbf24] via-[#fef08a] to-[#fbbf24]" data-id="element-155">
            <div className="bg-[#0a0517] rounded-3xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-156">
              <div className="absolute inset-0 bg-gradient-to-b from-[#fbbf24]/10 to-transparent" data-id="element-157" />
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#fbbf24]/10 rounded-full blur-3xl" data-id="element-158" />

              <div className="relative z-10" data-id="element-159">
                <motion.div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/15 border border-red-500/40 text-red-300 mb-5 text-xs" animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} data-id="element-160">
                  <Flame className="w-4 h-4" data-id="element-161" />
                  <span className="font-bold tracking-wider uppercase" data-id="element-162">
                    Solo por hoy
                  </span>
                </motion.div>

                <p className="text-white/60 text-sm uppercase tracking-widest mb-2" data-id="element-163">
                  Valor real
                </p>
                <p className="text-3xl md:text-4xl text-white/40 line-through mb-5 font-cinzel" data-id="element-164">
                  $49.990
                </p>

                <p className="text-[#fbbf24] text-sm uppercase tracking-widest font-bold mb-2" data-id="element-165">
                  Solo por hoy
                </p>
                <p className="text-6xl md:text-7xl font-bold text-gold-gradient mb-2 font-cinzel drop-shadow-[0_0_30px_rgba(251,191,36,0.4)]" data-id="element-166">
                  $19.990
                </p>
                <p className="text-white/50 text-sm mb-8" data-id="element-167">
                  Pago único · Acceso inmediato
                </p>

                <Button size="xl" className="w-full sm:w-auto" href="https://checkout.tusbeneficios.shop/cart/51012899700969:1" data-id="element-168">
                  QUIERO ACCEDER AHORA
                </Button>

                <div className="flex items-center justify-center gap-2 text-xs text-white/50 mt-5" data-id="element-169">
                  <Clock className="w-3.5 h-3.5" data-id="element-170" />
                  <span data-id="element-171">Oferta válida por tiempo limitado</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* What you receive list */}
        <div className="max-w-3xl mx-auto glass-panel-gold rounded-3xl p-8 md:p-10 relative overflow-hidden" data-id="element-172">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#fbbf24]/10 rounded-full blur-3xl" data-id="element-173" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#7c3aed]/10 rounded-full blur-3xl" data-id="element-174" />

          <div className="relative z-10" data-id="element-175">
            <motion.h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-176">
              Resumen de lo que{' '}
              <span className="text-gold-gradient" data-id="element-177">Recibes Hoy</span>
            </motion.h2>

            <ul className="space-y-3 mb-6 max-w-xl mx-auto" data-id="element-178">
              {stack.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.06
            }} className="flex items-center gap-4" data-id="element-179">
                  <div className="w-8 h-8 rounded-full bg-[#fbbf24]/20 flex items-center justify-center shrink-0" data-id="element-180">
                    <item.icon className="w-4 h-4 text-[#fbbf24]" data-id="element-181" />
                  </div>
                  <span className="text-base md:text-lg text-white/90" data-id="element-182">
                    {item.text}
                  </span>
                </motion.li>)}
            </ul>

            <div className="flex items-center justify-center gap-2 text-xs text-white/50 bg-black/20 p-3 rounded-xl border border-white/5 max-w-md mx-auto" data-id="element-183">
              <Lock className="w-3.5 h-3.5" data-id="element-184" />
              <span data-id="element-185">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}